import { Service } from '@angular/core';

export const aiSegments = {
    internal: 'internal',
    aiChat: 'ai-chat',
} as const;

const aiRoutes = {
    aiChat: [aiSegments.internal, aiSegments.aiChat],
};

@Service()
export class AiRouter {
    public getAiChatRoute(): string[] {
        return ['/', ...aiRoutes.aiChat];
    }
}
